import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=b99bf58a&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=b99bf58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99bf58a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b99bf58a')) {
      api.createRecord('b99bf58a', component.options)
    } else {
      api.reload('b99bf58a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=b99bf58a&scoped=true&", function () {
      api.rerender('b99bf58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UCdBER602c4z/JS/comp/DateRangeExt.vue"
export default component.exports